module.exports = __webpack_public_path__ + "static/user4-b2df1135cb6b51e986b0512928366508.png";